import React, { useState, useEffect } from 'react';

const WatchVideo = ({ setStep, setFormData }) => {
  const [videoSize, setVideoSize] = useState({ width: 380, height: 214 });
  const [message, setMessage] = useState('');

  useEffect(() => {
    const updateVideoSize = () => {
      const width = window.innerWidth;
      if (width <= 767) {
        setVideoSize({ width: 380, height: 170 });
        setMessage('動画部分右下の↔ボタンを押してからスマートフォンを横向きにすると大きな画面でご視聴いただけます。');
      } else if (width >= 768 && width <= 1023) {
        setVideoSize({ width: 760, height: 340 });
        setMessage('動画部分右下の↔ボタンを押してからタブレットを横向きにすると大きな画面でご視聴いただけます。');
      } else {
        setVideoSize({ width: 950, height: 425 });
        setMessage('動画部分右下の↔ボタンを押すと大きな画面でご視聴いただけます。');
      }
    };

    updateVideoSize();
    window.addEventListener('resize', updateVideoSize);

    return () => {
      window.removeEventListener('resize', updateVideoSize);
    };
  }, []);

  useEffect(() => {
    sessionStorage.setItem('lastPage', 'WatchVideo');
  }, []);

  useEffect(() => {
    const onPlayerStateChange = (event) => {
      // 再生データ（event.target.getCurrentTime() / getDuration() や
      // event.data === window.YT.PlayerState.ENDED）を記録したい場合はここで処理する。
      // 現在は何も行っていない。
    };

    const player = new window.YT.Player('youtube-player', {
      events: {
        'onStateChange': onPlayerStateChange
      }
    });

    return () => {
      player.destroy();
    };
  }, []);

  return (
    <div className="p-4 bg-blue-100 rounded-lg">
      <h2 className="common-title mb-4">骨密度検査を受けてみよう！</h2>
      <div className="video-background flex justify-center items-center mb-4">
        <div className="video-container rounded-lg overflow-hidden">
          <iframe
            id="youtube-player"
            title="骨密度検査の説明動画"
            width={videoSize.width}
            height={videoSize.height}
            src="https://www.youtube.com/embed/l7ayPW1cthE?rel=0&autoplay=1&mute=1&modestbranding=1&enablejsapi=1"
            style={{ border: 0, display: 'block', margin: 'auto' }}
            allow="autoplay; encrypted-media"
          ></iframe>
        </div>
      </div>
      <div className="mb-4"></div>
      <p className="text-center mb-4">{message}</p>
      <div className="mb-4"></div>
      <button 
        onClick={() => {
          setFormData({
            weight: '',
            age: '',
            gender: '',
            height: '',
            previousFracture: false,
            parentHipFracture: false,
            currentSmoking: false,
            glucocorticoids: false,
            rheumatoidArthritis: false,
            secondaryOsteoporosis: false,
            alcohol: false,
            dentalCheck: null,
            dentalIssue: null
          });
          setStep(0);
        }}
        className="main-menu-button bg-blue-500 text-white p-2 rounded hover:bg-blue-600"
      >
        最初の画面へもどる
      </button>
    </div>
  );
};

export default WatchVideo; 